import { CommonModule } from '@angular/common';
import { Component, Inject, Input } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
	selector: 'app-ai-generate-dialog-box',
	standalone: true,
	imports: [CommonModule, MatIconModule, MatProgressSpinnerModule],
	templateUrl: './ai-generate-dialog-box.component.html',
	styleUrl: './ai-generate-dialog-box.component.scss'
})
export class AiGenerateDialogBoxComponent {


	constructor(
		private dialogRef: MatDialogRef<AiGenerateDialogBoxComponent>,
	) { }

	close() {
		this.dialogRef.close();
	}

}